import { Color } from '@tmh-website/shared/colors';
import { ButtonHoverThemeColor, ButtonThemeColor } from '@tmh-website/ui/Button';
import { FormElementThemeColor } from '@tmh-website/ui/FormElements';

export type LocaleSwitchBannerThemeColor =
  | Color.Blue_900
  | Color.Blue_1000_Deep
  | Color.Neutral_0_White
  | Color.Neutral_200_OffWhite
  | Color.Neutral_900;

export interface LocaleSwitchBannerTheme {
  background: Color;
  text: Color;
  formElementThemeColor: FormElementThemeColor;
  buttonThemeColor: ButtonThemeColor;
  buttonHoverThemeColor: ButtonHoverThemeColor;
}

export const localeSwitchBannerThemes: { [key in LocaleSwitchBannerThemeColor]: LocaleSwitchBannerTheme } = {
  [Color.Blue_900]: {
    background: Color.Blue_900,
    text: Color.Neutral_0_White,
    formElementThemeColor: Color.Blue_1000_Deep,
    buttonThemeColor: Color.Blue_500_Ultramarine,
    buttonHoverThemeColor: Color.Neutral_0_White,
  },
  [Color.Blue_1000_Deep]: {
    background: Color.Blue_1000_Deep,
    text: Color.Neutral_0_White,
    formElementThemeColor: Color.Blue_1000_Deep,
    buttonThemeColor: Color.Blue_500_Ultramarine,
    buttonHoverThemeColor: Color.Neutral_0_White,
  },
  [Color.Neutral_0_White]: {
    background: Color.Neutral_0_White,
    text: Color.Blue_1000_Deep,
    formElementThemeColor: Color.Neutral_0_White,
    buttonThemeColor: Color.Blue_500_Ultramarine,
    buttonHoverThemeColor: Color.Blue_1000_Deep,
  },
  [Color.Neutral_200_OffWhite]: {
    background: Color.Neutral_200_OffWhite,
    text: Color.Blue_1000_Deep,
    formElementThemeColor: Color.Neutral_200_OffWhite,
    buttonThemeColor: Color.Blue_500_Ultramarine,
    buttonHoverThemeColor: Color.Blue_1000_Deep,
  },

  /**
   * This theme variant has been added WITHOUT designs using the AI-generated color scheme,
   * based on the previously defined color variants.
   */
  [Color.Neutral_900]: {
    background: Color.Neutral_900,
    text: Color.Neutral_0_White,
    formElementThemeColor: Color.Neutral_800,
    buttonThemeColor: Color.Blue_500_Ultramarine,
    buttonHoverThemeColor: Color.Neutral_0_White,
  },
};
